<div >
    <a class="btn btn-link btn-icon btn-icon--left btn-back hidden"
       [routerLink]="(clinicId) ? ['/clinics'] : ['/home']">
        {{ 'back' | translate }}
    </a>
    <app-breadcrumb *ngIf="!clinicId && !clinic; else specificBreadcrumb"
            [firstNode]="{label: 'Users list', 'url': '/home'}">
    </app-breadcrumb>
    <ng-template #specificBreadcrumb>
        <app-breadcrumb
                        [data]="[{label: 'Users list', 'url': '/home'}, {label: 'Edit Templates', 'url': ''}]">
        </app-breadcrumb>
    </ng-template>

    <div class="box-shadow">
        <div class="card card--box">
            <div class="card--box__header">
                <div class="card--box__header--info">
                    <div class="card--box__header__title help-btn">
                        <h2>
                            <div *ngIf="clinicId && clinic" class="card--box__header__title">
                                <h6>{{ 'Template name' | translate }}</h6>
                                <h2>
                                    {{ clinic.name | translate }}, <span>{{ clinic.city | translate }}</span>
                                </h2>
                            </div>
                            <div *ngIf="!clinicId" class="card--box__header__title">
                                {{ 'Template name' | translate }}
                            </div>
                            <app-popover [templateType]="HELP_TEMPLATE_LIST" iconClass="popover-icon--white ml-1" containerClass="patient-list-help"
                                placement="bottom"></app-popover>
                        </h2>
                    </div>
                </div>
            </div>
            <div class="card-block card--box__block">
                <div class="row">
                    <div class="col-xs-10 col-xl-10">
                        <div class="sprite card--box__search">
                            <input class="form-control card--box__search__input"
                               (keyup.enter)="search()"
                                placeholder="{{ 'Search by content' | translate }}"
                                [(ngModel)]="searchTerms"/>
                        </div>
                    </div>
                    <div class="col-xs-2 col-xl-2">
                        <button type="button" class="btn btn-primary btn-block "
                                (click)="search()">
                            <i class="fas fa-search"></i>
                            {{ 'Search' | translate }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="table--grid email-template-table">
            <div class="table--grid__body">
                <div class="row">
                    <div class="col-xs-11 col-lg-11">
                        <div class="row">
                            <div class="col-xs-12">
                                <span>
                                    {{ 'Template name' | translate }}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row" *ngFor="let emailTemplate of allTemplates">
                    <div class="col-xs-8 col-lg-8">
                        <div class="row">
                            <div class="col-xs-12">
                                <span>
                                   {{ emailTemplate.name  | translate }}
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="col-xs-4 col-lg-4 table--grid__actions table--grid__actions--hover">
                        <ul class="list-inline">
                            <li class="list-inline-item" [routerLink]="['edit/' + emailTemplate['id'] + '/DE/' + clinicId]">
                                <a title="{{ 'Click here to edit' | translate }}">
                                    <img src="/assets/icon/flags/de.png" alt="German">
                                </a>
                            </li>
                            <li class="list-inline-item" [routerLink]="['edit/' + emailTemplate['id'] + '/FR/' + clinicId]">
                                <a title="{{ 'Click here to edit' | translate }}">
                                    <img src="/assets/icon/flags/fr.png" alt="German">
                                </a>
                            </li>
                            <li class="list-inline-item" [routerLink]="['edit/' + emailTemplate['id'] + '/IT/' + clinicId]">
                                <a title="{{ 'Click here to edit' | translate }}">
                                    <img src="/assets/icon/flags/it.png" alt="German">
                                </a>
                            </li>
                            <li class="list-inline-item" [routerLink]="['edit/' + emailTemplate['id'] + '/EN/' + clinicId]">
                                <a title="{{ 'Click here to edit' | translate }}">
                                    <img src="/assets/icon/flags/en.png" alt="English">
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
                <ng-template [ngIf]="!allTemplates || allTemplates.length === 0">
                    <div class="row text-xs-center">
                        {{ 'No email template is matched your search criteria.' | translate }}
                        <a (click)="resetSearch()" class="text-primary back-btn">({{ 'Back to list' | translate }})</a>
                    </div>
                </ng-template>
            </div>
        </div>
    </div>
</div>
<router-outlet></router-outlet>
